import React from "react"
import "./ChangeText.scss"
import PropTypes from "prop-types"
import {
  complianceNumberConverter,
  NO_DATA,
  NOT_ENOUGH_DATA,
} from "@swipesense/compliance-helpers"
import {
  NR_MIN_OPPORTUNITIES,
  BSR_MIN_OPPORTUNITIES,
} from "../../helpers/sharedConstants"
import { Stats } from "@swipesense/shared_components_v2/dist/index"

const ChangeText = ({ change, opportunities, bsrCompliance }) => {
  let className = ""
  let text
  change = Math.round(
    complianceNumberConverter(
      change,
      opportunities,
      bsrCompliance ? BSR_MIN_OPPORTUNITIES : NR_MIN_OPPORTUNITIES
    )
  )

  /* istanbul ignore else */
  if (change === NO_DATA || isNaN(change)) {
    className = "no-data-change"
    text = "-"
  } else if (change === NOT_ENOUGH_DATA) {
    className = "not-enough-data-change"
    text = "-"
  } else if (change > 0) {
    return <Stats increaseOccurrence={true} percent={change} />
  } else if (change < 0) {
    return <Stats increaseOccurrence={false} percent={change} />
  } else if (change === 0) {
    className = "no-change-change"
    text = "no change"
  }

  return (
    <div className="ChangeText">
      <div className={className}>{text}</div>
    </div>
  )
}

ChangeText.propTypes = {
  change: PropTypes.number,
  opportunities: PropTypes.number,
  bsrCompliance: PropTypes.bool,
}

export default ChangeText
